module.exports = __webpack_public_path__ + "static/media/bg25.bd4a4ba8.jpg";